import { getDoc, doc } from "firebase/firestore";
import { updateDoc } from "firebase/firestore";
import db from "../firebase/fireInit";

async function saveMoodInHistory(mood, playerId) {
  const docRef = doc(db, `players/${playerId}/moodsHistory`, mood.type);
  const moodDoc = await getDoc(docRef);
  const array = moodDoc.data().array;

  updateDoc(docRef, { array: [...array, mood] });
}

export { saveMoodInHistory };
